import React from "react"

import styled from "styled-components"

import { EmptyStateImageSize } from "./enumeration"

export const EmptyStateImageContainer = React.memo(styled.div<{
  size: EmptyStateImageSize
}>`
  ${({ size }) => {
    switch (size) {
      case EmptyStateImageSize.Large:
        return `
        max-width: 246px;
        min-width: 246px;
      `
      case EmptyStateImageSize.Medium:
      default:
        return `
        max-width: 181px;
        min-width: 181px;
      `
    }
  }}
`)

export const StyledImg = React.memo(styled.img`
  width: 100%;
  height: auto;
  display: block;
`)
